import type { AdminKey, JobKey } from '../catalog';
import { asPlantId } from '../types';
import type { ExceptionKey, PlantId } from '../types';

export type AccessRule =
  | { readonly kind: 'signedIn' }
  | { readonly kind: 'job'; readonly key: JobKey }
  | { readonly kind: 'admin'; readonly key: AdminKey }
  | { readonly kind: 'exception'; readonly key: ExceptionKey }
  | { readonly kind: 'internal'; readonly rule: AccessRule }
  | { readonly kind: 'anyOf'; readonly rules: readonly AccessRule[] }
  | { readonly kind: 'allOf'; readonly rules: readonly AccessRule[] };

export const signedIn: AccessRule = { kind: 'signedIn' };

export const job = (key: JobKey): AccessRule => ({ kind: 'job', key });

export const admin = (key: AdminKey): AccessRule => ({ kind: 'admin', key });

export const exception = (key: ExceptionKey): AccessRule => ({ kind: 'exception', key });

export const internal = (rule: AccessRule): AccessRule => ({ kind: 'internal', rule });

export const anyOf = (first: AccessRule, ...rest: readonly AccessRule[]): AccessRule => ({ kind: 'anyOf', rules: [first, ...rest] });

export const allOf = (first: AccessRule, ...rest: readonly AccessRule[]): AccessRule => ({ kind: 'allOf', rules: [first, ...rest] });

export type Scope =
  | { readonly kind: 'plant'; readonly plantId: PlantId }
  | { readonly kind: 'anyPlant' }
  | { readonly kind: 'unresolved' };

export const anyPlant: Scope = { kind: 'anyPlant' };

export const unresolved: Scope = { kind: 'unresolved' };

const MISSING_IDS: ReadonlySet<string> = new Set(['', 'null', 'undefined']);

export const atPlant = (plantId: string | null | undefined): Scope => {
  const id = plantId?.trim() ?? '';
  return MISSING_IDS.has(id) ? unresolved : { kind: 'plant', plantId: asPlantId(id) };
};
